import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from './Util/Session/session.service';
import { map } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransferOrderToBranchService {

  constructor(
    private http: HttpClient,
    private session: SessionService
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  TransferOrderToOtherBranchReport(Detail: any) {
    return this.http.post<any>(environment.API_URL + `TransferOrderToOtherBranch`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      return response;
    }));
  }

}
